export const URL_HASH_PREFIX = '#';
export const WIX_PROTOCOL = 'wix:';
export function encodeText(text) {
    return encodeURIComponent(text);
}
export function alignIfLegacy(url, type) {
    const { protocol } = new URL(url);
    return protocol === `${type}:` ? `${WIX_PROTOCOL}${url}` : url;
}
export function decodeText(s) {
    if (!s) {
        return s;
    }
    return decodeURIComponent(s);
}
//# sourceMappingURL=converters-utils.js.map